import React, { useEffect, useState } from "react";
import {
  getPriceDeltaValues,
  getEarnings,
  getCompanyInformation,
} from "../Service/data";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

const CandleChartSubHeader = (props) => {
  const [priceDeltaData, setPriceDeltaData] = useState();
  const [priceDeltaLoading, setPriceDeltaLoading] = useState(true);

  const [earnings, setEarnings] = useState();
  const [earningsLoading, setEarningsLoading] = useState(true);

  const [companyInfo, setCompanyInfo] = useState();
  const [companyInfoLoading, setCompanyInfoLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        getPriceDeltaValues(props.name).then((data) => {
          setPriceDeltaData(data);
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // const fetchEarnings = async () => {
    //   try {
    //     getEarnings(props.name).then((data) => {
    //       setEarnings(data);
    //     });
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // }

    const fetchCompanyInfo = async () => {
      try {
        getCompanyInformation(props.name).then((data) => {
          setCompanyInfo(data);
          setCompanyInfoLoading(false);
          setEarningsLoading(false);
          if (data) {
            if (data["revenue"]) setEarnings(data["revenue"]);
            else setEarnings("NA");
          }
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // fetchData();
    // fetchEarnings();
    fetchCompanyInfo();
  }, []);

  useEffect(() => {
    if (
      priceDeltaData !== undefined &&
      priceDeltaData !== null &&
      priceDeltaData.length > 0
    ) {
      setPriceDeltaLoading(false);
    }
  }, [priceDeltaData]);

  useEffect(() => {
    if (earnings !== undefined && earnings !== null && earnings.length > 0) {
      setEarningsLoading(false);
    }
  }, [earnings]);

  useEffect(() => {
    if (companyInfo !== undefined && companyInfo !== null) {
      setCompanyInfoLoading(false);
    }
  }, [companyInfo]);

  const getFormattedInfo = (companyInfo) => {
    let result = `${companyInfo["name"]}`;
    if (companyInfo["sector"]) {
      result = `${result} | ${companyInfo["sector"]}`;
    }
    return result;
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", maxWidth: "350px" }}
    >
      <div>
        {companyInfoLoading && <CircularProgress />}
        {companyInfo !== null && companyInfo !== undefined && (
          <Typography variant="subtitle2">
            {getFormattedInfo(companyInfo)}
          </Typography>
        )}
      </div>
      <div>
        {earningsLoading && <CircularProgress />}
        {earnings !== null && earnings !== undefined && (
          <Typography variant="subtitle2">{`Earnings: ${earnings}`}</Typography>
        )}
      </div>
      <div>
        {/* {priceDeltaLoading && <CircularProgress/>}
      <Stack direction="row">
        {priceDeltaData !== null &&
          priceDeltaData !== undefined &&
          priceDeltaData.map((row) => {
            return (
              <div>
                {row.value && <Chip variant="outlined" label={`${row.name}: ${row.value}`} color={row.value >= 0 ? "success" : "error"} size="small" />}
              </div>
            );
          })}
      </Stack> */}
      </div>
    </div>
  );
};

export default CandleChartSubHeader;
